import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { InertiaQueryParamsService } from '@/modules/shared/services/inertia-query-params.service'

@Component
export class QsSearchableMixin extends Vue {
  constructor(
    protected readonly qs: InertiaQueryParamsService
  ) {
    super()
  }

  private get search() {
    return this.qs.params.s
  }

  private set search(value) {
    this.qs.setParamOptimised(
      's',
      value === '' ? null : value
    )
  }
}
